function getRankByAdjacentUnits(position, allUnits, rules, agentSide) {
    let rank = 0;
    const neighbours = rules.getExistingNeighbours(position);
    let numOfAdjacentEnemies = 0;
    let numOfAdjacentFriends = 0;
    neighbours.forEach((neighbour) => {
        const unitOnPosition = rules.getUnitOnPosition(neighbour, allUnits);
        if (!unitOnPosition) {
            return;
        }
        if (unitOnPosition.side === agentSide) {
            numOfAdjacentFriends += 1;
        }
        else {
            numOfAdjacentEnemies += 1;
        }
    });
    if (numOfAdjacentFriends === 1) {
        rank += 0.5;
    }
    else if (numOfAdjacentFriends === 2) {
        rank += 1;
    }
    else if (numOfAdjacentFriends === 3) {
        rank += 0.75;
    }
    else if (numOfAdjacentFriends === 4) {
        rank += 0.5;
    }
    else if (numOfAdjacentFriends === 5) {
        rank += 0.25;
    }
    if (numOfAdjacentEnemies === 0) {
        rank += 0.2;
    }
    return rank;
}
export default getRankByAdjacentUnits;
